import { imageType } from "api/interfaces/home/home.type";
import { useCustomScreenSize } from "hoc/useScreenSize";
import homeStyles from "modules/home/garage/styles.module.scss";
import dynamic from "next/dynamic";
import HomeGarage from "./garage/HomeGarage";
import { StyledOverlayBox } from "./garage/StyledHomeGarageRegular.style";
// import HomepageCTABanner from "./HomeCtaBanner";
import HomepageBannerComponent from "./HomepageBannerComponent";
import UtilityGrid from "./utility-grid/utility-grid";
const AccountOverviewWrapper = dynamic(() => import(/* webpackChunkName: "account-overview-wrapper" */"./personalisation/account-overview/AccountOverviewWrapper"));

interface IProps {
  bannersWebp?: imageType,
  baseImageUrl?: string,
}

function BannerWrapper(props: IProps) {
  const { baseImageUrl = process.env.NEXT_PUBLIC_CMS, bannersWebp } = props;
  const isDesktop = useCustomScreenSize({ minWidth: 1025 });
  return (
    <>
      <div className={`d-flex ${homeStyles.banner_wrapper}`} style={{ margin: "0 auto" }}>
        <div className={homeStyles.left_wrapper}>
          {isDesktop
            && (
              <>
                <StyledOverlayBox>
                  <HomeGarage />
                </StyledOverlayBox>
                <AccountOverviewWrapper />
              </>
            )}
        </div>
        <HomepageBannerComponent
          baseImageUrl={baseImageUrl}
          bannersWebp={bannersWebp}
        />
      </div>
      <div className={`d-flex m-b-10 ${homeStyles.banner_wrapper}`} style={{ margin: "0 auto" }}>
        <UtilityGrid />
      </div>

      {/* <HomepageBannerComponent
        banners={banners}
        desktopHomeGarage={isDesktop ? (
          <StyledOverlayBox>
            <HomeGarage />
          </StyledOverlayBox>
        ) : null}
      /> */}
    </>
  );
}

export default BannerWrapper;
